// Define application wide routes
const ROUTE_PATH = {
  LOGIN: '/login',
  DASHBOARD: '/',
  CONTENT_CHANNELS: '/content/channels',
  CONTENT_VIDEOS: '/content/videos',
  CONTENT_SEQUENCE: '/content/sequence',
  CONTENT_SEQUENCE_CATEGORY: '/categories',
  CONTENT_SEQUENCE_PLAYLIST: '/playlist',
  CONTENT_TABS: '/content/tabs',
  SUBSCRIBERS: '/subscribers',
  ADMIN_USERS: '/users',
  LOGOUT: '/logout',
};

export default ROUTE_PATH;
